export const formatAdminPrice = (
  price: string | number,
  includeCurrency = false,
  precision = 0,
): string => {
  const num = Number(price);
  if (isNaN(num)) return "";
  const formatted = num.toLocaleString("de-CH", {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  });
  return includeCurrency ? `CHF ${formatted}` : formatted;
};
